import type { Method } from 'axios';
import axios from 'axios';

import configs from '../config';
import routes from '../routes/routes.constants';

const { API_URL, NETWORK_REQUEST_TIMEOUT_IN_MILLIS, PARSE_APPLICATION_ID } =
  configs;

export function getSessionToken() {
  // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
  const res = JSON.parse(localStorage.getItem('okta-token-storage'))
    ?.accessToken?.accessToken;
  return res;
}

export function getExternalJwtToken() {
  return localStorage.getItem('external-jwt-token');
}

export function setExternalJwtToken(token: string) {
  localStorage.setItem('external-jwt-token', token);
}

// Public route axios instance - uses JWT token from localStorage
export const jwtAxiosInstace = axios.create({
  baseURL: API_URL,
  timeout: NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  headers: {
    'Content-Type': 'application/json',
    appVersion: process.env.VITE_VERSION,
  },
});

// Authenticated route axios instance - uses Okta tokens
export const oktaAxiosInstance = axios.create({
  baseURL: API_URL,
  timeout: NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  headers: {
    'Content-Type': 'application/json',
    appVersion: process.env.VITE_VERSION,
  },
});

// Helper function to determine if current route is public
export const isPublicRoute = (): boolean => {
  const pathname = window.location.pathname;
  if (pathname === '/') {
    const hash = window.location.hash;
    const hashPath = hash.replace('#', '');
    // Split by ? to remove query parameters, then by / to get segments
    const pathWithoutQuery = hashPath.split('?')[0];
    const segments = pathWithoutQuery.split('/').filter(Boolean);
    const firstSegment = segments[0];

    return (
      firstSegment === routes.PATIENT_DOWNLOADABLE.replace('/', '') ||
      firstSegment === routes.PUBLIC.replace('/', '')
    );
  }

  return pathname === routes.PATIENT_DOWNLOADABLE || pathname === routes.PUBLIC;
};

// Helper function to get the appropriate axios instance based on route
export const getAxiosInstanceForRoute = () => {
  return isPublicRoute() ? jwtAxiosInstace : oktaAxiosInstance;
};

export async function makeRequest(url: any, params = {}, method = 'GET') {
  if (
    process.env.VITE_SALES_DEMO_ENV &&
    'serviceWorker' in navigator &&
    navigator.serviceWorker.controller
  ) {
    navigator.serviceWorker.controller.postMessage('MOCK_ACTIVATE');

    // Small wait for changes to propagate
    await new Promise((resolve) => {
      setTimeout(resolve, 10);
    });
  }
  return await getAxiosInstanceForRoute()({
    method,
    url,
    ...params,
    timeout: NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  });
}

// The api currently requires the requests to have a content-type of plain :(
const DEFAULT_HEADERS = { 'Content-Type': 'text/plain' };

// We are using Parse server as our backend and it requires that all requests be a POST
// with a body that contains an "_method" key that defines what HTTP method should
// actually be used.

export function makeAPIRequest(path = '', params = {}, method = 'GET') {
  const newParams = {
    ...params,
    data: {
      // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
      ...params.data,
      _ApplicationId: PARSE_APPLICATION_ID,
    },
    headers: {
      ...DEFAULT_HEADERS,
      // @ts-expect-error TS(2339): Property 'headers' does not exist on type '{}'.
      ...params.headers,

      appVersion: process.env.VITE_VERSION,
    },
  };
  return makeRequest(`${API_URL}${path}`, newParams, method);
}

// Set session token via headers instead of the body. We prefer to use headers
// instead of the body because we want to make sure  we aren't storing session
// tokens in logs and by separating the concerns we drastically reduce any
// incidences from happening. In addition to this we now remove the dependency of
// every request being a POST request since a body is no longer needed.
// NOTE any parse specific endpoints will need to use @makeAPIRequest for compatibility
export function makeAPIRequestOkta(
  path = '',
  params = {},
  method = 'GET',
  auth = { idToken: '', nonce: '' },
) {
  const newParams = {
    ...params,
    headers: {
      'Content-Type': 'application/json',
      OktaIdToken: auth.idToken,
      OktaNonce: auth.nonce,
      // @ts-expect-error TS(2339): Property 'headers' does not exist on type '{}'.
      ...params.headers,
    },
  };
  return makeRequest(`${API_URL}${path}`, newParams, method);
}

export function makeAPIRequestV2(
  path = '',
  params = {},
  method: Method = 'GET',
) {
  const instance = getAxiosInstanceForRoute();

  const newParams = {
    ...params,
    headers: {
      'Content-Type': 'application/json',
      // @ts-expect-error TS(2339): Property 'headers' does not exist on type '{}'.
      ...params.headers,

      appVersion: process.env.VITE_VERSION,
    },
  };

  return instance({
    method,
    url: `${API_URL}${path}`,
    ...newParams,
    timeout: NETWORK_REQUEST_TIMEOUT_IN_MILLIS,
  });
}

export const uploadFileToS3 = async (signedUrl: any, file: any) =>
  await axios.put(signedUrl, file, {
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    },
  });

export function getAccessToken() {
  // @ts-expect-error TS(2345): Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
  const res = JSON.parse(localStorage.getItem('okta-token-storage'))
    ?.accessToken?.accessToken;
  return res;
}
